import { render, staticRenderFns } from "./CloseServiceOrder.vue?vue&type=template&id=462a2374&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./CloseServiceOrder.vue?vue&type=style&index=0&id=462a2374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462a2374",
  null
  
)

export default component.exports